import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M18.427 18.073a.25.25 0 0 1 .054.273.25.25 0 0 1-.408.08L16 16.354l-2.073 2.074a.25.25 0 0 1-.354-.354L15.647 16l-2.074-2.073a.25.25 0 0 1 .354-.354L16 15.646l2.073-2.073a.25.25 0 1 1 .354.354L16.354 16zM15.625 4.375A.625.625 0 0 1 15 5h-2.674L8.992 15h2.258a.624.624 0 1 1 0 1.25H5A.625.625 0 1 1 5 15h2.674l3.334-10H8.75a.625.625 0 0 1 0-1.25H15a.625.625 0 0 1 .625.625" }, null, -1)
  ]))]))
}
export default { render: render }